import * as yup from 'yup';

export enum ErrorCode {
  CITY_NOT_EXIST = 'city_not_exist',
  DEFAULT = 'default',
  DONATION_PUBLIC_SEARCH = 'donation_public_search',
  HAS_NOT_EMAIL = 'has_not_email',
  HAS_NOT_URL = 'has_not_url',
  INVALID_OTP = 'invalid_otp',
  INVALID_PASSWORD = 'invalid_password',
  IS_EMAIL = 'is_email',
  NOT_AVAILABLE = 'not_available',
  OVER_QUOTA = 'over_quota',
  PASSWORD_FORMAT = 'password_format',
  QUOTA = 'quota',
  REQUIRED = 'required',
  USER_LOGIN = 'user_signin',
  USER_STATE = 'user_state',
  VALIDATION = 'validation',
}

type ErrorStatusCode = 400 | 401 | 403 | 404 | 500 | 503;

const transKeys = {
  required: 'errors.inputs.required',
  is_email: 'errors.inputs.email',
  user_signin: 'errors.bad-login',
  invalid_password: 'errors.bad-login',
  password_format: 'errors.inputs.password',
  city_not_exist: 'errors.city-not-exist',
  not_available: 'errors.email-already-exists',
  invalid_otp: 'errors.otp-invalid',
  over_quota: 'errors.over_quota',
  has_not_url: 'errors.inputs.has_not_url',
  has_not_email: 'errors.inputs.has_not_email',
  user_state: 'errors.user-state',
} satisfies { [key in ErrorCode]?: string };

export const codeToTransKey = (code: ErrorCode | undefined): string => {
  if (!code) return 'errors.unknown';

  // @ts-expect-error do not want to map all errors
  return transKeys[code] ?? 'errors.unknown';
};

export const errorResultToTransKey = (err?: ErrorResult): { message: string; code: string } => {
  const errors = Object.entries(err?.errors ?? {});

  if (errors.length > 0) {
    const [key, messageResult] = errors[0];

    return {
      message: codeToTransKey(messageResult.code),
      code: `${key} : ${messageResult.code}`,
    };
  }

  return {
    message: codeToTransKey(err?.error.code),
    code: `global : ${err?.error.code}`,
  };
};

export interface ErrorMessageResult {
  code: ErrorCode;
  message?: string;
}

export interface ErrorResult {
  extra?: string[];
  status?: ErrorStatusCode;
  errors?: {
    [key: string]: ErrorMessageResult;
  };
  error: ErrorMessageResult;
}

export const uploadResultSchema = yup.object({
  uuid: yup.string().required(),
  url: yup.string().required(),
});

export type UploadResult = yup.InferType<typeof uploadResultSchema>;
